import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Products from 'views/cash/closeBox/products'; // Importing Products view
import OtherExpenses from 'views/cash/closeBox/otherExpenses'; // Importing OtherExpenses view
import OtherIncome from 'views/cash/closeBox/otherIncome'; // Importing OtherIncome view
import CreditCards from 'views/cash/closeBox/creditCards'; // Importing CreditCards view
import Total from 'views/cash/closeBox/total'; // Importing Total view
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the activation of the registration view.
 * @extends JetView
 */
export default class activateRegistrationView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current instance
        const screen = this.app.config.size; // Screen size configuration

        // Check if cash box is already closed
        if (profile.CloseCashBox) {
            vthis.show('/top/'); // Redirect to the top view
            webix.alert({
                type: 'alert-error',
                title: 'Error',
                text: _('Ya se efectuó el cierre de día, no es posible realizar esta operación'), // Alert message in Spanish
            });
        }

        // Configuration for products section
        const products = {
            css: 'int-left',
            rows: [Products], // Including Products view
        };

        // Configuration for other expenses section
        const otherExpenses = {
            css: 'int-left',
            rows: [OtherExpenses], // Including OtherExpenses view
        };

        // Configuration for credit cards section
        const creditCards = {
            css: 'int-left',
            rows: [CreditCards], // Including CreditCards view
        };

        // Configuration for other income section
        const otherIncome = {
            css: 'int-left',
            rows: [OtherIncome], // Including OtherIncome view
        };

        // Configuration for total section
        const total = {
            css: 'int-left',
            rows: [Total], // Including Total view
        };

        /**
         * Function to handle cashier view display.
         * @param {string} id - The ID of the cashier.
         */
        function cashierView(id) {
            vthis.app.callEvent('viewCashier', [{ Id: id }]); // Trigger event to view cashier
            $$('cajero').setValue('Cajero ' + id); // Set cashier ID in the UI
            $$('BtnAddExpensesContainer').hide(); // Hide expenses button container
            $$('BtnAddIncomesContainer').hide(); // Hide incomes button container
            $$('BtnAddCreditCardContainer').hide(); // Hide credit card button container
            $$('gridProduct2').hide(); // Hide product grid
            $$('totalAccordion').hide(); // Hide total accordion
        }

        var obj = [{}]; // Initialize an empty object array
        const btnViewCashiers = [
            {
                view: 'button',
                id: 'btnViewCashiers',
                name: 'btnViewCashiers',
                css: 'back-button',
                type: 'icon',
                label: _('Volver'), // Back button label in Spanish
                icon: 'wxi-angle-left', // Back button icon
                click: function () {
                    vthis.app.callEvent('viewCashier', [{ Id: '' }]); // Trigger event to reset cashier view
                    webix.ui(btnViewBetShop, this.getParentView()); // Show bet shop view
                    $$('cajero').hide(); // Hide cashier input
                    $$('BtnAddExpensesContainer').show(); // Show expenses button container
                    $$('BtnAddIncomesContainer').show(); // Show incomes button container
                    $$('BtnAddCreditCardContainer').show(); // Show credit card button container
                    $$('gridProduct2').show(); // Show product grid
                    $$('totalAccordion').show(); // Show total accordion
                },
            },
        ];

        // AJAX request to fetch cashier data
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetCashierSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Display error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response text to JSON
                    obj = resp.Data; // Store cashier data
                    var cont = 0; // Initialize counter
                    while (cont < obj.length) {
                        btnViewCashiers.push({
                            view: 'button',
                            id: obj[cont].id, // Set button ID to cashier ID
                            name: obj[cont].id, // Set button name to cashier ID
                            label: 'Cajero ' + obj[cont].id, // Button label
                            click: function (id, event) {
                                cashierView(id); // Call cashier view function
                            },
                        });
                        cont = cont + 1; // Increment counter
                    }
                },
            });

        // Configuration for bet shop view buttons
        const btnViewBetShop = [
            {
                hidden: devConfig.getPermAction('btnViewCashiers', 'Add'), // Hide button based on permissions
                css: 'prm-btnViewCashiers',
            },
            {
                view: 'button',
                value: _('Ver por un cajero en especifico'), // Button label in Spanish
                click: function () {
                    webix.ui(btnViewCashiers, this.getParentView()); // Show cashier buttons
                    $$('cajero').show(); // Show cashier input
                },
                hidden: !devConfig.getPermAction('btnViewCashiers', 'Add'), // Hide button based on permissions
                css: 'prm-btnViewCashiers',
            },
        ];

        webix.ui.fullScreen(); // Set UI to full screen mode

        // Configuration for upper section of the view
        const upper_section = {
            id: 'b5',
            rows: [
                {
                    collapsed: true,
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    cols: [
                        {
                            minWidth: 200,
                            rows: [
                                {
                                    cols: [
                                        {
                                            hidden: devConfig.getPermAction('btnViewCashiers', 'Add'), // Hide if no permission
                                            css: 'prm-btnViewCashiers',
                                        },
                                        {
                                            view: 'toolbar',
                                            hidden: !devConfig.getPermAction('btnViewCashiers', 'Add'), // Hide if no permission
                                            css: 'prm-btnViewCashiers',
                                            elements: [
                                                {
                                                    view: 'button',
                                                    value: _(
                                                        'Ver por un cajero en especifico', // Button label in Spanish
                                                    ),
                                                    click: function () {
                                                        webix.ui(
                                                            btnViewCashiers,
                                                            this.getParentView(), // Show cashier buttons
                                                        );
                                                        $$('cajero').show(); // Show cashier input
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    hidden: !devConfig.getPermAction('btnViewCashiers', 'Add') && !obj.length > 0, // Hide if no permission and no cashiers
                                    css: 'prm-btnViewCashiers',
                                    view: 'text',
                                    id: 'cajero',
                                    value: 'Cajero #', // Default value for cashier input
                                    disabled: true, // Disable input
                                    css: 'dashboard-stats',
                                },
                                {
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    cols: [
                                        {
                                            id: '9',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: false,
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: _('Productos'), // Accordion header in Spanish
                                                    body: {
                                                        rows: [products], // Include products section
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    cols: [
                                        {
                                            id: '10',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: screen == 'small' ? true : false, // Collapse based on screen size
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: _('Otros Egresos'), // Accordion header in Spanish
                                                    body: {
                                                        rows: [
                                                            {
                                                                id: 'BtnAddExpensesContainer',
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        view: 'button',
                                                                        value: _(
                                                                            'Añadir Egreso', // Button label in Spanish
                                                                        ),
                                                                        width: 120,
                                                                        id: 'BtnAddExpenses', // Button ID
                                                                        click: () => {
                                                                            this.app.callEvent('expensesAdd', [{}]); // Trigger event to add expenses
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            otherExpenses, // Include other expenses section
                                                        ],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    cols: [
                                        {
                                            id: '10',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: screen == 'small' ? true : false, // Collapse based on screen size
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: _('Otros Ingresos'), // Accordion header in Spanish
                                                    body: {
                                                        id: 'b8',
                                                        rows: [
                                                            {
                                                                id: 'BtnAddIncomesContainer',
                                                                responsive: 'b8',
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        view: 'button',
                                                                        value: _(
                                                                            'Añadir Ingreso', // Button label in Spanish
                                                                        ),
                                                                        id: 'BtnAddIncomes', // Button ID
                                                                        minWidth: 250,
                                                                        width: screen == 'small' ? 0 : 150,
                                                                        click: () => {
                                                                            this.app.callEvent('incomesAdd', [{}]); // Trigger event to add incomes
                                                                        },
                                                                    },
                                                                    {
                                                                        view: 'button',
                                                                        value: _(
                                                                            'Añadir Ingreso Producto Cupo', // Button label in Spanish
                                                                        ),
                                                                        minWidth: 250,
                                                                        width: screen == 'small' ? 0 : 250,
                                                                        id: 'BtnAddIncomesProductQuota', // Button ID
                                                                        click: () => {
                                                                            this.app.callEvent(
                                                                                'incomesAddProductQuota',
                                                                                [{}],
                                                                            ); // Trigger event to add income product quota
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            otherIncome, // Include other income section
                                                        ],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    cols: [
                                        {
                                            id: '10',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: screen == 'small' ? true : false, // Collapse based on screen size
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: _(
                                                        'Ingresos Tarjetas de crédito', // Accordion header in Spanish
                                                    ),
                                                    body: {
                                                        rows: [
                                                            {
                                                                id: 'BtnAddCreditCardContainer',
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        view: 'button',
                                                                        value: _(
                                                                            'Añadir ingreso por tarjeta', // Button label in Spanish
                                                                        ),
                                                                        id: 'BtnAddCreditCard', // Button ID
                                                                        width: 250,
                                                                        click: () => {
                                                                            this.app.callEvent('creditCardsAdd', [{}]); // Trigger event to add credit card income
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            creditCards, // Include credit cards section
                                                        ],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            collapsed: true,
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            margin: 15,
                            width: screen == 'small' ? 0 : 250,
                            minWidth: 250,
                            id: 'totalAccordion',
                            cols: [
                                {
                                    id: '9',
                                    multi: true,
                                    view: 'accordion',
                                    css: 'betShop',
                                    collapsed: false,
                                    paddingY: 10,
                                    type: 'clean',
                                    rows: [
                                        {
                                            header: 'Total', // Accordion header for total
                                            body: {
                                                rows: [total], // Include total section
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Return the main configuration object for the view
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    height: 'auto',
                    responsive: 'a5',
                    type: 'wide',
                    cols: [upper_section], // Include upper section in the layout
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        $$('cajero').hide(); // Hide cashier input initially
        const _ = this.app.getService('locale')._; // Localization service
        webix.ready(function () {
            if (screen.width < 500) {
                // Additional setup for small screens can be added here
            }
        });
        var vthis = this; // Reference to the current instance
        var popupAddBeginDate = ''; // Initialize variable for the popup
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2); // Format current date

        // Configuration for the popup to add the beginning date
        popupAddBeginDate = webix.ui({
            view: 'window',
            id: 'AddBeginDay',
            width: 450,
            height: 450,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Inicio Día'), align: 'center' }, // Popup title in Spanish
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                            vthis.show('/top/dashboard'); // Redirect to dashboard
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Make the popup modal
            body: {
                view: 'form',
                id: 'addformBeginDay',
                elements: [
                    {
                        view: 'text',
                        label: _('Fecha: '), // Label for date input in Spanish
                        labelWidth: 150,
                        name: 'CreatedLocalDate',
                        value: createdLocalDate, // Set current date as value
                        readonly: true, // Make the input read-only
                    },
                    {
                        view: 'text',
                        type: 'number',
                        label: _('Valor Inicio de día:'), // Label for start value input in Spanish
                        name: 'Value',
                        labelWidth: 150,
                        required: true, // Mark as required
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: 'Cancelar', // Cancel button label
                                click: function () {
                                    this.getTopParentView().hide(); // Close the popup
                                    var vvthis = this;
                                    $$('addformBeginDay').setValues($$('addformBeginDay').getCleanValues()); // Reset form values
                                    vthis.show('/top/dashboard'); // Redirect to dashboard
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: 'Enviar', // Submit button label
                                click: function ($e) {
                                    var values = $$('addformBeginDay').getValues(); // Get form values
                                    if ($$('addformBeginDay').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Accounting/SaveBeginDate',
                                                '{ "Amount":"' + values.Value + '"}', // Send start value
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Display error message
                                                        );
                                                        vthis.show(
                                                            '/top/dashboard', // Redirect to dashboard
                                                        );
                                                        $$('addformBeginDay').getTopParentView().hide(); // Close the popup
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response text to JSON
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: '¡Error!', // Error message title in Spanish
                                                                type: 'alert-error',
                                                                text: 'Ocurrio un error, comuniquese con soporte', // Error message in Spanish
                                                            });
                                                            vthis.show(
                                                                '/top/dashboard', // Redirect to dashboard
                                                            );
                                                            $$('addformBeginDay').getTopParentView().hide(); // Close the popup
                                                        } else {
                                                            profile.BeginDay = true; // Set profile to indicate day has begun
                                                            webix.message(
                                                                'Inicio de día! ', // Display success message
                                                            );
                                                            $$('addformBeginDay').setValues(
                                                                $$('addformBeginDay').getCleanValues(),
                                                            ); // Reset form values
                                                            $$('addformBeginDay').getTopParentView().hide(); // Close the popup
                                                            vthis.getTopParentView().hide(); // Hide the parent view
                                                            window.location.reload(); // Reload the page
                                                        }
                                                    },
                                                },
                                            );
                                    } else {
                                        webix.message({
                                            title: '¡Error!', // Error message title in Spanish
                                            type: 'alert-error',
                                            text: 'Completa los campos...', // Error message in Spanish
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate fields on change
                        },
                    },
                },
            },
        });

        // Show the popup if the day has not begun
        if (!profile.BeginDay) {
            popupAddBeginDate.show();
        }
        console.log(profile); // Log the profile for debugging
    }
}

// FILE DOCUMENTED
